import { STATIC_SET_CONSTANTS } from '@utils/Util';

export const PLANNING_STATUS = {
	COMPLETED: 'COMPLETED',
	PENDING: 'PENDING',
	SUBMITTED: 'SUBMITTED'
};

export const productionSteps = (orderCancelInfo) => {
	return [
		{ label: 'Order info', key: 'Order info', condition: true },
		{ label: 'PI', key: 'PI', condition: orderCancelInfo?.status !== 'APPROVED' },
		{ label: 'Supplier', key: 'Supplier', condition: orderCancelInfo?.status !== 'APPROVED' },
		{ label: 'Sales contract', key: 'Sales contract', condition: orderCancelInfo?.status !== 'APPROVED' },
		{ label: 'Material list', key: 'Material list', condition: orderCancelInfo?.status !== 'APPROVED' },
		{
			label: 'Commercial invoice',
			key: 'Commercial invoice',
			condition: orderCancelInfo?.status !== 'APPROVED'
		},
		{ label: 'Payment', key: 'Payment', condition: orderCancelInfo?.status !== 'APPROVED' }
	];
};

export const isProductOfSet = (product) => {
	return product?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT;
};

export const isPlaningCompleated = (item) => {
	return (
		item?.planningStatus === PLANNING_STATUS.COMPLETED ||
		item?.planningStatus === PLANNING_STATUS.SUBMITTED
	);
};

export const isPlaningPending = (item) => {
	return item?.planningStatus === PLANNING_STATUS.PENDING;
};

export const INITIAL_TASK_MODAL_STATE = {
	taskName: '',
	deliverableName: '',
	stepName: '',
	duration: '',
	startDate: '',
	startDateOrg: '',
	endDate: ''
};

export const CREATE_TASK_MODAL_REQUIRED_FIELDS = {
	taskName: { required: true, label: 'Name' },
	deliverableName: { required: true, label: 'Deliverable name' },
	stepName: { required: true, label: 'Dependent task' },
	duration: { required: true, label: 'Standard duration' },
	startDate: { required: false, label: 'Start Date' },
	startDateOrg: { required: false, label: 'Start Date Org' },
	endDate: { required: false, label: 'End Date' }
};

export const GROUP_BY_TASK_LIST = 'deliverableId';
export const SUB_TASK_LABEL = 'subTask';

export const TNA_REQUEST_TYPE = {
	TEMPLATE: 'TEMPLATE',
	EXCEL_FILE: 'EXCEL_FILE'
};

export const isSetProduct = (style) => style?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT;
export const isPack = (style) => style?.setPackStyleFlag === STATIC_SET_CONSTANTS.PACK_PRODUCT;
export const isTnaCompleated = (style) => style?.planningStatus !== PLANNING_STATUS.PENDING;

export const tabFilterMap = {
	PENDING: 'PENDING',
	RUNNING: 'RUNNING',
	COMPLETED: 'COMPLETED',
	ORDER_DASHBOARD: 'ORDER_DASHBOARD',
	ON_SHIPMENT: 'ON_SHIPMENT',
	CANCEL: 'CANCEL'
};

// used in MyOrder.js
export const MY_ORDER_INITIAL_STATE = {
	projectList: [],
	page: 0,
	size: 15,
	loading: false,
	activeTab: 'ORDER_DASHBOARD',
	isPendingTab: false,
	filterBy: '',
	sort: ['RUNNING', 'PENDING', 'COMPLETED', 'ON_SHIPMENT', 'CANCEL'],
	project_type: ['BULK', 'DEVELOPMENT', 'SUPERVISION'],
	hasNext: false,
	height: window.innerHeight,
	userInfo: {},
	runningCount: 0,
	pendingCount: 0,
	completedCount: 0,
	cancelCount: 0,
	shipmentCount: 0,
	search: '',
	isSearching: false,
	totalElements: 0,
	showFilter: false,
	showSummary: true,
	queryParams: ''
};

export function getGroupPoData(poData) {
	const groupPoData = poData.reduce((acc, item) => {
		// Find if the productReferenceNumber group already exists
		let group = acc.find((g) => g.productReferenceNumber === item.productReferenceNumber);

		if (!group) {
			// Create a new group if it doesn't exist
			group = {
				productReferenceNumber: item.productReferenceNumber,
				name: item.name,
				poData: []
			};
			acc.push(group);
		}

		// Add the current item to the group
		group.poData.push({
			productId: item.productId,
			productReferenceNumber: item.productReferenceNumber,
			...item // Add the rest of the properties
		});

		return acc;
	}, []);
	return groupPoData;
}

export const incoTerms = [
	{ label: 'CIF', value: 'CIF', id: 'CIF' },
	{ label: 'FOB', value: 'FOB', id: 'FOB' },
	{ label: 'FCA', value: 'FCA', id: 'FCA' }
];
